module.exports = __webpack_public_path__ + "static/img/area-icon5.0988fc76.png";